import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { NAVBAR_BASE_CONTAINER_HEIGHT } from '../../Navbar.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const useNavbarContainerHeight = () => {
  const { bottom: safeAreaBottomInset } = useSafeAreaInsets();

  // ─── Derived ────────────────────────────────────────────────────────

  const height = NAVBAR_BASE_CONTAINER_HEIGHT + safeAreaBottomInset;

  // ─── Styles ─────────────────────────────────────────────────────────

  const offsetStyle = useStyle(() => ({ bottom: height }), [height]);
  const paddingStyle = useStyle(() => ({ paddingBottom: height }), [height]);

  // ────────────────────────────────────────────────────────────────────

  return { height, offsetStyle, paddingStyle };
};
